import { combineReducers } from 'redux';
import projects from './projects';
import categories from './categories';
import templates from './templates';
import emails from './emails';
import metrics from './metrics';
import auth from './auth';
import apiKeys from './apiKeys';
import webhooks from './webhooks';
import domains from './domains';
import admin from './admin';
import user from './user';
import general from './general';

const appReducer = combineReducers({
  projects,
  categories,
  templates,
  emails,
  metrics,
  auth,
  apiKeys,
  webhooks,
  domains,
  admin,
  user,
  general,
});

export default (state, action) => appReducer(state, action);
